module.exports = __webpack_public_path__ + "img/transfer-none.f8924435.svg";